<textarea
  class="form-control"
  [class.is-invalid]="showError"
  [formControl]="formControl"
  [rows]="props.rows ?? 3"
  [formlyAttributes]="field"
  [attr.data-testid]="props.testId"
></textarea>
